import { usePreventWindowScroll } from '@simplywallst/ui-core';

export const PreventWindowScroll = () => {
  usePreventWindowScroll();
  return null;
};
